import { combineReducers } from "redux";
import { persistReducer} from 'redux-persist';
import storage from "redux-persist/lib/storage";

import tranReducer from "./reducers/tranReducer";
import nominateReducer from "./reducers/nominateReducer";
import participateReducer from "./reducers/participateReducer";
import registerReducer from "./reducers/register";
import exhibitionReducer from "./reducers/exhibition";

const persistConfig = {
    key: "root",
    storage,
    whitelist: ["transac"]
}

const rootReducer = combineReducers({
   transac: tranReducer,
   nominated: nominateReducer,
   participated: participateReducer,
   registerBus: registerReducer,
   exhibShow: exhibitionReducer
});

export default persistReducer(persistConfig, rootReducer)